import {
  AdminApproveMcDocument,
  AdminFetchMcReviewDocuments,
  AdminRejectMcDocument,
} from 'src/constants/actionTypes'
import type { McReviewQueueRow } from 'src/interfaces/mcDocumentReview'
import { extractApiErrorMessages } from 'src/utils/errorHandlers'
import { Action } from 'src/utils/reduxUtils'
import { McDocumentReviewState } from './types'

const resolveApiErrorMessage = (error: unknown, fallback: string): string => {
  const messages = extractApiErrorMessages(error)

  if (messages.length === 0) {
    return fallback
  }

  return messages.join(', ')
}

const getInitialState = (): McDocumentReviewState => ({
  documents: [],
  documentsLoading: false,
  documentsError: null,
  submitting: false,
})

export const mcDocumentReviewReducer = (
  state: McDocumentReviewState = getInitialState(),
  action: Action<unknown>,
): McDocumentReviewState => {
  switch (action.type) {
    case AdminFetchMcReviewDocuments.type.REQUEST:
      return {
        ...state,
        documentsLoading: true,
        documentsError: null,
      }
    case AdminFetchMcReviewDocuments.type.SUCCESS:
      return {
        ...state,
        documents: (action.payload as McReviewQueueRow[]) ?? [],
        documentsLoading: false,
        documentsError: null,
      }
    case AdminFetchMcReviewDocuments.type.FAILED:
      return {
        ...state,
        documentsLoading: false,
        documentsError: resolveApiErrorMessage(
          action.payload,
          'Failed to load the master contractor queue',
        ),
      }

    case AdminApproveMcDocument.type.REQUEST:
    case AdminRejectMcDocument.type.REQUEST:
      return { ...state, submitting: true }

    case AdminApproveMcDocument.type.SUCCESS:
    case AdminApproveMcDocument.type.FAILED:
    case AdminRejectMcDocument.type.SUCCESS:
    case AdminRejectMcDocument.type.FAILED:
      return { ...state, submitting: false }

    default:
      return state
  }
}
